<template>
<div class="form-step-item">
    <div class="panel">
        <div class="intro">
            <h3>Thank you for your request</h3>
            <p>Your patient's registration details have been sent to our Customer Service team and will be processed as soon as possible.</p>
            <p>We have emailed a copy of your patient's details to you for your records.</p>
        </div>
    </div>
</div>
</template>


<script>

export default {
    name: 'StepSuccess',
    components: {
    },
    props: {
    },
    data() {
        return {
        };
    },
    validations: {
    },
    computed: {
    },
    methods: {
    },
};
</script>
